import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import { reducer as toastrReducer } from "react-redux-toastr";

import { MainStateInterface } from "scenes/MainPage/interfaces";
import { MapStateInterface } from "scenes/MapPage/interfaces";
import { AuthStateInterface } from "scenes/AuthPage/interfaces";
import { ImageDetectionStateInterface } from "scenes/ImageDetectionPage/interfaces";
import { ProjectReportStateInterface } from "scenes/ProjectReportPage/interfaces";
import { ModalStateInterface } from "scenes/Modal/interfaces";
import { UnitsManagerStateInterface } from "scenes/UnitsManager/interfaces";
import { TeamAndStaffInterface } from "scenes/TeamAndStaffPage/interfaces";
import { MissionsManagerStateInterface } from "scenes/MissionsManager/interfaces";
import { LayersManagerStateInterface } from "scenes/LayersManager/interfaces";

import features from "features";

interface IReducer {
  toastr: any;
  main: MainStateInterface;
  map: MapStateInterface;
  auth: AuthStateInterface;
  imageDetection: ImageDetectionStateInterface;
  projectReport: ProjectReportStateInterface;
  teamAndStaff: TeamAndStaffInterface;
  modal: ModalStateInterface;
  unitsManager: UnitsManagerStateInterface;
  layersManager: LayersManagerStateInterface;
  missionsManager: MissionsManagerStateInterface;
}

export const rootReducers = combineReducers<IReducer>({
  toastr: toastrReducer,
  main: features.main.reducer,
  map: features.map.reducer,
  auth: features.auth.reducer,
  imageDetection: features.imageDetection.reducer,
  projectReport: features.projectReport.reducer,
  teamAndStaff: features.teamAndStaff.reducer,
  modal: features.modal.reducer,
  unitsManager: features.unitsManager.reducer,
  layersManager: features.layersManager.reducer,
  missionsManager: features.missionsManager.reducer
});

export const rootSagas = function* rootSaga() {
  yield all([
    features.auth.saga(),
    features.main.saga(),
    features.map.saga(),
    features.imageDetection.saga(),
    features.projectReport.saga(),
    features.teamAndStaff.saga(),
    features.unitsManager.saga(),
    features.layersManager.saga(),
    features.missionsManager.saga()
  ]);
};

export type RootStateInterface = ReturnType<typeof rootReducers>;
